import { NielsenEventTag, NielsenEventValue, NielsenGateway, NielsenSDK } from '../types';

/**
 * A gateway that sends the events to the Nielsen SDK.
 */
export class NielsenBrowserGateway implements NielsenGateway {
  #sdkInstance;
  constructor(sdk: NielsenSDK, appId: string, instanceName: string, consent: Promise<boolean>) {
    this.#sdkInstance = consent.then(consentValue => {
      return sdk.nlsQ(appId, instanceName, {
        enableFpid: `${consentValue}`,
        nol_sdkDebug: false,
        // nol_sdkDebug: 'debug', // 'debug'
      });
    });
  }

  async send(tag: NielsenEventTag, value: NielsenEventValue) {
    const instance = await this.#sdkInstance;
    switch (tag) {
      case 'Load':
        instance.ggPM('loadMetadata', value);
        break;
      case 'Playhead':
        instance.ggPM('setPlayheadPosition', value);
        break;
      case 'Stop':
        instance.ggPM('stop', value);
        break;
      case 'Buffering':
        instance.ggPM('stop', value);
        break;
      case 'End':
        instance.ggPM('end', value);
        break;
    }
  }
}
